import { z } from 'zod';
const versionedIdentifier = z.string().min(5).max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const assetsAssistantContextCapability = 'assets.assistant-context.v1';
export const assetsAssistantContextProviderId = assetsAssistantContextCapability;
export const assetsAssistantContextSlot = 'platform.server.optional-context';
export const assetsAssistantContextRequestSchema = z.strictObject({
    requestId: z.string().uuid(),
    subjectType: z.enum(['assets.asset', 'projects.project']),
    subjectId: z.string().uuid().nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(versionedIdentifier).min(1).max(50),
    redactionProfile: z.string().min(2).max(80).regex(/^[a-z][a-z0-9-]*$/),
    maxFacts: z.number().int().min(1).max(500),
});
export const assetsAssistantContextFactSchema = z.strictObject({
    factType: z.enum(['assets.asset-summary', 'assets.project-placement-summary']),
    value: z.record(z.string().min(1).max(120), z.unknown()),
    sourceRevision: z.string().min(1).max(160),
    observedAt: z.string().datetime({ offset: true }),
    redactedFields: z.array(z.string().min(1).max(512)).max(100),
});
export const assetsAssistantContextResultSchema = z.strictObject({
    providerId: z.literal(assetsAssistantContextProviderId),
    providerModuleId: z.literal('assets'),
    capability: z.literal(assetsAssistantContextCapability),
    facts: z.array(assetsAssistantContextFactSchema).max(1),
    unavailableReason: z.enum([
        'not-entitled',
        'not-enabled',
        'permission-denied',
        'provider-failed',
    ]).nullable(),
});
//# sourceMappingURL=assets-assistant-context.contract.js.map